import Alpine from 'alpinejs';
import axios from '../../config/axios.js';

Alpine.data('kasirInvitationThemeReviews', () => ({
  loading: true,
  items: [],
  apiBase: '/api/v1/kasir/engagement/invitation-templates',

  init() {
    this.load();
  },

  async load() {
    this.loading = true;
    try {
      const { data } = await axios.get('/api/v1/kasir/engagement/invitation-theme/reviews');
      this.items = data.data || [];
    } catch (e) {
      window.toast?.(e.response?.data?.message || 'Gagal memuat antrian review.', 'error');
      this.items = [];
    } finally {
      this.loading = false;
    }
  },

  async approve(t) {
    try {
      const { data } = await axios.post(`${this.apiBase}/${t.id}/approve`);
      window.toast?.(data.message || 'Template disetujui.', 'success');
      await this.load();
    } catch (e) {
      window.toast?.(e.response?.data?.message || 'Gagal approve.', 'error');
    }
  },

  async publish(t) {
    try {
      const { data } = await axios.post(`${this.apiBase}/${t.id}/publish`);
      window.toast?.(data.message || 'Template dipublikasikan.', 'success');
      await this.load();
    } catch (e) {
      window.toast?.(e.response?.data?.message || 'Gagal publish.', 'error');
    }
  },
}));
